import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import moment from 'moment';

import { OrigamiResponse, ServiceBase } from './base/service.base';
import { TopicField } from '@app/origami-api/utils/topic-utils';
import { ErrorCode } from '@app/origami-api/constants/error-codes';
import { FolderManagementServiceModel } from '@app/origami-api/services/folder-management.service';

export namespace CountriesBulkUploadService {
  export interface CountriesBulkDocumentUploadOptions {
    file: File;
    siteId: number;
    batchId?: number;
    doNotChangeStatusCode: number;
    unpackArchives: boolean;
    convertToPdf: boolean;
    fullPath: string;
    essentialForId: string;
    essentialFor: number;
    amendmentProfileId: string;
  }

  export interface CountriesBulkUploadResult {
    ErrorList: any[];
    UploadedDocuments: SSUBulkUploadDocument[];
  }

  export interface SSUBulkUploadDocument extends FolderManagementServiceModel.Document {
    DocReplaceOption: number;
    FileName: string;
    IsDocumentCollected: boolean;
    SSUDocumentTopicId: number;
    SSUMetaDataFields: TopicField[];
    StartupHistory: SSUHistoryModel[];
  }

  export interface SSUHistoryModel {
    CreatedBy: string;
    RecordDate: string;
    EventType: number;
  }

  export interface SSUUpdateMetadataOptions {
    amendmentProfileId: string;
    essentialFor: number;
    essentialForId: string;
    siteId: string;
    ssuDocList: SSUBulkUploadDocument[];
  }

  export interface ProcessUploadedFileProcessingOptions {
    MetaData?: TopicField[];
    UnpackArchive: boolean;
    ConvertToPDF: boolean;
    TmfApplicable?: boolean;
    BatchId?: number;
    RelativeFilePath: string;
  }

  export interface ProcessUploadedFileOptions {
    siteId: number;
    fileToken: string;
    processingOptions: ProcessUploadedFileProcessingOptions;
  }

  export interface ProcessUploadedFileResult {
    BatchId?: number;
    ErrorCode?: ErrorCode;
    ErrorRecords?: any[];
    FileNames?: string[];
  }
}

@Injectable()
// eslint-disable-next-line no-redeclare
export class CountriesBulkUploadService extends ServiceBase {
  serviceUrl = 'EssentialDocumentsService.svc';

  public bulkDocumentUpload(
    body: CountriesBulkUploadService.CountriesBulkDocumentUploadOptions,
  ): Observable<OrigamiResponse<CountriesBulkUploadService.CountriesBulkUploadResult>> {
    const formData: FormData = new FormData();
    const batchId = body.batchId ? body.batchId.toString() : null;
    const options = {
      headers: {
        'Current-Date': moment(new Date()).format('MM/DD/YYYY'),
      },
    };

    formData.append('file', body.file, body.file.name);
    formData.append('siteId', body.siteId.toString());
    formData.append('FILEPATH_0', body.fullPath || body.file.name);
    formData.append('BATCHID', batchId || null);
    formData.append('DoNotChangeStatusCode', '1'); // hardcoded
    formData.append('##EssentialFor##', body.essentialFor.toString());
    formData.append('unpackArchives', body.unpackArchives ? '1' : '0');
    formData.append('convertToPdf', body.convertToPdf ? '1' : '0');
    formData.append('##EssentialForId##', body.essentialForId);
    formData.append('##AMENDMENTPROFILEID##', body.amendmentProfileId ? body.amendmentProfileId : null);

    // if (body.tmfApplicable !== undefined) {
    //   formData.append('TMFAPPLICABLE', body.tmfApplicable ? '1' : '0');
    // }

    return this.origamiPost('/BulkSSUDocumentUpload', formData, options, null, true);
  }

  public updateMetadata(
    options: CountriesBulkUploadService.SSUUpdateMetadataOptions,
  ): Observable<OrigamiResponse<any>> {
    return this.origamiPost('/SaveEssentialDocumentsState', options, null, null, null);
  }

  // TODO: maybe, after fix backend need change to KENDO UPLOAD ?
  public processUploadedFile(
    params: CountriesBulkUploadService.ProcessUploadedFileOptions,
    silentErrors?: ErrorCode[],
  ): Observable<OrigamiResponse<CountriesBulkUploadService.ProcessUploadedFileResult>> {
    return this.origamiPost('/ProcessUploadedFile', params, null, silentErrors, true);
  }
}
